export class TransactionNotFoundException extends Error {}
